<app-dropdown
	name="mortgageChargeType"
	[disabled]="isDisabled"
	[ngModel]="_mortgage?.chargeType | titlecase"
	(onSelect)="onSelectChargeType($event)"
	[itemGroups]="[{ items: chargeTypesDropdownOptions }]"
	[forceErrorState]="forceErrorState"
>
</app-dropdown>
